import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fa216d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-relative" }
const _hoisted_2 = { class: "jr-text-center jr-text-primary jr-mb-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-xxs jr--mb-3.5 jr-ml-4" }, "(%)", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarChart = _resolveComponent("BarChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _hoisted_3,
    _createVNode(_component_BarChart, _mergeProps({ class: "barchart" }, _ctx.barChartProps), null, 16)
  ]))
}